import {Injectable} from '@angular/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class MatPaginatorIntlNgxTranslateService extends MatPaginatorIntl {
  private readonly itemsPerPageTranslateKey =
    'm2.sprint2.paginator.itemsPerPage';
  private readonly nextPageTranslateKey = 'm2.sprint2.paginator.nextPage';
  private readonly previousPageTranslateKey =
    'm2.sprint2.paginator.previousPage';
  private readonly firstPageTranslateKey = 'm2.sprint2.paginator.firstPage';
  private readonly lastPageTranslateKey = 'm2.sprint2.paginator.lastPage';

  constructor(private readonly translate: TranslateService) {
    super();

    this.translate.onLangChange.subscribe(() => this.initialize());
    this.initialize();
  }

  initialize() {
    this.translate
      .get([
        this.itemsPerPageTranslateKey,
        this.nextPageTranslateKey,
        this.previousPageTranslateKey,
        this.firstPageTranslateKey,
        this.lastPageTranslateKey
      ])
      .subscribe(translation => {
        this.itemsPerPageLabel = translation[this.itemsPerPageTranslateKey];
        this.nextPageLabel = translation[this.nextPageTranslateKey];
        this.previousPageLabel = translation[this.previousPageTranslateKey];
        this.firstPageLabel = translation[this.firstPageTranslateKey];
        this.lastPageLabel = translation[this.lastPageTranslateKey];

        this.changes.next();
      });
  }

  getRangeLabel: (page: number, pageSize: number, length: number) => string = (
    page: number,
    pageSize: number,
    length: number
  ) => {
    if (length === 0 || pageSize === 0) {
      return `0 / ${length}`;
    }

    length = Math.max(length, 0);

    const startIndex = page * pageSize;

    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex =
      startIndex < length
        ? Math.min(startIndex + pageSize, length)
        : startIndex + pageSize;

    return this.translate.instant('m2.sprint2.paginator.rangeLabel', {
      start: startIndex + 1,
      end: endIndex,
      length
    });
  };
}
